import { render, staticRenderFns } from "./fluxoService.vue?vue&type=template&id=19849021&scoped=true&"
import script from "./fluxoService.vue?vue&type=script&lang=js&"
export * from "./fluxoService.vue?vue&type=script&lang=js&"
import style0 from "./fluxoService.vue?vue&type=style&index=0&id=19849021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19849021",
  null
  
)

export default component.exports